import { useSEO } from '../hooks/useSEO';
import { getBlock } from '../content';
import Hero from '../components/Hero';
import Ticker from '../components/Ticker';
import Numbers from '../components/Numbers';
import FullbleedQuote from '../components/FullbleedQuote';
import Portfolio from '../components/Portfolio';
import PartnersCarousel from '../components/PartnersCarousel';
import BrazilMap from '../components/BrazilMap';
import Aquicultura from '../components/Aquicultura';
import Contact from '../components/Contact';

export default function Home() {
  useSEO(getBlock('page.home').seo);
  return (
    <main>
      <Hero />
      <Ticker />
      <Numbers />
      <FullbleedQuote />
      <Portfolio />
      <PartnersCarousel />
      <BrazilMap />
      <Aquicultura />
      <Contact />
    </main>
  );
}